// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3x46V","toggleWrap":"styles_toggleWrap__o_lIX","content":"styles_content__JxfDO","selectAreaCode":"styles_selectAreaCode__htWUV"};